import { createContext } from 'react';

export type TanstackClientContextProps = {};

export default createContext<Partial<TanstackClientContextProps>>({});
